$ = require 'jquery'
Dialog = require 'app/scripts/views/lib/dialog'
{ Key, registerShortcut, Scope, unregisterShortcut, } = require '@trello/keybindings'
PluginModalView = require 'app/scripts/views/plugin/plugin-modal-view'
PopOver = require 'app/scripts/views/lib/pop-over'
SidebarState = require 'app/scripts/view-models/sidebar-state'
{ track } = require '@trello/analytics'

module.exports = PluginModal = new class

  @modalView = null

  onShortcut: =>
    @close()
    track 'Keyboard Shortcuts', 'Esc - Hide Plugin Modal', 'Plugin Modal'

  isOpen: -> @modalView?

  update: (content) ->
    if !@modalView?
      console?.warn('Warning: No modal open')
      return
    else if content.idPlugin != @modalView.content.idPlugin
      console?.warn('Can not update modal you did not open')
      return

    @modalView.update(content)

  open: (args) ->
    { model, content } = args

    PopOver.hide()
    SidebarState.hideUnpinnedSidebar()
    if Dialog.isVisible
      Dialog.hide(true)

    @close()

    @modalView = new PluginModalView({ model, content, fxClose: @close.bind(@) })

    $('.pop-over').before(@modalView.render().el)

    # events
    @modalView.$el.click (e) ->
      if !$(e.target).closest('.plugin-chrome-wrapper').length && !$('.pop-over.is-shown').length
        # clicked outside the modal and no popovers open -> close the modal
        PluginModal.close()
      return

    registerShortcut(@onShortcut, { scope: Scope.Dialog, key: Key.Escape })

    return

  close: ->
    if @isOpen()
      unregisterShortcut(@onShortcut)
      @modalView.close()
      @modalView = null
    return
